import { useEffect, useState } from 'react';
import '../../css/modals.css';
import axios from 'axios';
import {  useNavigate } from 'react-router-dom';
import PipeCard from './PipeCard';
import StagesMenu from './StagesMenu';
import ConvProgressMenu from './ConvProgressMenu';
export default function ModalPipeline(props) {
   const navigate = useNavigate();
   const [visibility, setVisibility] = useState('none');
   const [inputs, setInputs] = useState({...props.inputs });
   const [data,setData] =  useState([]);
   const [dataStageTypes,setDataStageTypes] =  useState([]);
   const [dataConversations,setDataConversations] =  useState([]);
   const [chosenStageType, setChosenStageType] =  useState(props.stageType);
   const [satatus, setSatatus] = useState('wait');
   const modalHideHundler = () => {
      setVisibility('none');
      props.stateHundler('none');
   }
 
   useEffect(()=>{
      if(props.modalState === 'menu'){
        
         setVisibility('flex');
      }else{
         setVisibility('none');
      }
      
   },[props.modalState]);
  
   

   useEffect(()=>{
      

      axios.get('/api/stage-types', { withCredentials: true })
         .then(response => {
            setDataStageTypes([]);
            setDataStageTypes(response.data);
            setSatatus('none');
         })
         .catch(err => {
            setSatatus('error');
            console.log(err);
         });

        axios.get('/api/stages?stageType='+chosenStageType, { withCredentials: true })
         .then(response => {
            setData([]);
            setData(response.data);
            setSatatus('none');
         })
         .catch(err => {
            setSatatus('error');
            console.log(err);
         });
         if(!props.client || !props.client.id) {
            return;
         }
        axios.get(props.urlConversationsProgress+'?client='+ new Number(props.client.id) , { withCredentials: true })
         .then(response => {
            setDataConversations([]);
            setDataConversations(response.data);
            setSatatus('none');
         })
         .catch(err => {
            setSatatus('error');
            console.log(err);
         });
     },[props.modalState])

     const stopProp = (e) => {
           e.stopPropagation();
     }

  return (
    <div className='modal-menu' onClick={modalHideHundler} style={{display:visibility}} >
      <div className='pipeline-modal-container'  onClick={stopProp} >
         <div className='pipe-modal-close-btn' onClick={modalHideHundler} title='×'>×</div>
         <div className='pipe-modal-left-panel'>
           <ConvProgressMenu
              id={props.id} client={props.client}
              stateHundler={props.stateHundler}
                          onRefresh={props.onRefreshHundler}
                             stages={dataConversations} modalState={props.modalState}
                          ></ConvProgressMenu>
         </div>
         <StagesMenu  key={chosenStageType}
            id={props.id} client={props.client}
            stateHundler={props.stateHundler} 
                        onRefresh={props.onRefreshHundler}
                           stages={data}
                           satgeTypes={dataStageTypes}
                           setChosenStageType={setChosenStageType}
                           chosenStageType={chosenStageType}
                        ></StagesMenu>
      </div>

      {/* <ClientWindow inputs={inputs} selectors={props.selectors} url={props.toUpdate}   onRefreshHundler={props.onRefreshHundler}  name={props.name} title={props.title} /> */}
    </div>
  )
}
